import type { CollaboratorsRepositoryT } from "../../domain/ports/collaborators.repository";

type GetCollaboratorsParamsT = {
  collaboratorsRepository: CollaboratorsRepositoryT;
};

export const getCollaborators = async ({
  collaboratorsRepository,
}: GetCollaboratorsParamsT) => collaboratorsRepository.getAll();
